import { Injectable } from '@angular/core';
import { AnalyticsGraphFormat } from '../analytics.interfaces';

import { convertSecondsToTimeString } from '../../../core/metrics.helper';

@Injectable()
export class AnalyticsChartService {
  public formatStatValue(value: string, format: AnalyticsGraphFormat): string {
    if (!value) {
      value = '0';
    }
    switch (format) {
      case 'percent':
        return parseFloat(value).toFixed(2) + '%';
      case 'time': {
        return convertSecondsToTimeString(parseFloat(value));
      }
      default:
        return parseFloat(parseFloat(value).toFixed(2)).toString();
    }
  }

  public hasData(graphData: any): boolean {
    return graphData !== null && graphData.length > 0;
  }
}
